import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styles from './ItemSelectedCycle.module.scss';
import api from '../../../services/api';
import Loading from '../../Shared/Loading';
import { useProtocolPanel } from '../ProtocolPanelContext';
import { recordLengthFormatter } from '../../../utils/recordLengthFormatter';

export default function ItemSelectedCycle({ item }) {
  const { t } = useTranslation();
  const { navigateToEcg, isReadOnly } = useProtocolPanel();
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function fetchImage() {
      if (!item.image?.url) return;

      try {
        const response = await api.get(`${item.image.url}`, { responseType: 'blob' });

        if (response.status === 202) {
          const retryAfterHeader = response.headers['retry-after'];
          const retryAfterSeconds = retryAfterHeader ? parseInt(retryAfterHeader, 10) : 5;

          if (isMounted) {
            setTimeout(fetchImage, retryAfterSeconds * 1000);
          }
        } else {
          const imageUrl = URL.createObjectURL(response.data);
          if (isMounted) {
            setImageSrc(imageUrl);
          }
        }

      } catch (error) {
        console.error('Error fetching image:', error);
      }
    }

    fetchImage();

    return () => {
      isMounted = false;
    };

  }, [item?.image?.url]);

  const hasCycleSelected = item.image?.cycleNumber && item.image.cycleNumber > 0;
  const rPeakTimeFormatted = item.image?.rPeakTimeMs
    ? recordLengthFormatter(item.image.rPeakTimeMs / 1000, true)
    : null;

  const buttonText = hasCycleSelected
    ? t('consultation.protocol.selectedCycle.selectAnother')
    : t('consultation.protocol.selectedCycle.selectCycle');

  if (!imageSrc) {
    return <div className={styles.loadingContainerFiller}><Loading /></div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.imageContainer}>
          <img src={imageSrc} alt={item.image?.alt || 'Selected Cardiac Cycle'} className={styles.image} />
        </div>
        <div className={styles.metadata}>
          {hasCycleSelected ? (
            <>
              <div className={styles.cycleNumber}>
                {t('consultation.protocol.selectedCycle.cycleLabel', { number: item.image.cycleNumber })}
              </div>
              {rPeakTimeFormatted && (
                <div className={styles.rPeakTime}>
                  {t('consultation.protocol.selectedCycle.rPeakLabel', { time: rPeakTimeFormatted })}
                </div>
              )}
            </>
          ) : (
            <div className={styles.noCycle}>
              {t('consultation.protocol.selectedCycle.noCycleSelected')}
            </div>
          )}
        </div>
      </div>
      {!isReadOnly && (
        <Button variant="primary" className={styles.button} onClick={navigateToEcg}>
          {buttonText}
        </Button>
      )}
    </div>
  );
}
